import { createAction } from 'redux-actions'

const SET_TOTAL_PRICE = 'SET_TOTAL_PRICE'
const setTotalPrice = createAction(SET_TOTAL_PRICE)

function totalPrice(state = 0, { type, payload }) {
  switch (type) {
    case SET_TOTAL_PRICE:
      return payload
    default:
      return state
  }
}

const SET_SELECTED_TRIP = 'SET_SELECTED_TRIP'
const setSelectedTrip = createAction(SET_SELECTED_TRIP)

function selectedTrip(state = {}, { type, payload }) {
  switch (type) {
    case SET_SELECTED_TRIP:
      return payload
    default:
      return state
  }
}

const SET_SHOP_INFO = 'SET_SHOP_INFO'
const setShopInfo = createAction(SET_SHOP_INFO)

function shopInfo(state = window.shop || {}, { type, payload }) {
  switch (type) {
    case SET_SHOP_INFO:
      return payload
    default:
      return state
  }
}

const SET_SELECTED_CABINS = 'SET_SELECTED_CABINS'
const setSelectedCabins = createAction(SET_SELECTED_CABINS)

function selectedCabins(state = [], { type, payload }) {
  switch (type) {
    case SET_SELECTED_CABINS:
      return payload
    default:
      return state
  }
}

const SET_GUESTS_SPLITTING = 'SET_GUESTS_SPLITTING'
const setGuestsSplitiing = createAction(SET_GUESTS_SPLITTING)

function guestsSplitting(state = [], { type, payload }) {
  switch (type) {
    case SET_GUESTS_SPLITTING:
      return payload
    default:
      return state
  }
}

const SET_ROOM_PARAMS = 'SET_ROOM_PARAMS'
const setRoomParams = createAction(SET_ROOM_PARAMS)

function roomParams(state = [], { type, payload }) {
  switch (type) {
    case SET_ROOM_PARAMS:
      return payload
    default:
      return state
  }
}

const SET_STEP = 'SET_STEP'
const setStep = createAction(SET_STEP)

function step(state = 1, { type, payload }) {
  switch (type) {
    case SET_STEP:
      return payload
    default:
      return state
  }
}

export {
  setTotalPrice,
  totalPrice,
  setSelectedTrip,
  selectedTrip,
  shopInfo,
  setShopInfo,
  setSelectedCabins,
  selectedCabins,
  setGuestsSplitiing,
  guestsSplitting,
  setStep,
  step,
  setRoomParams,
  roomParams,
}
